(function () {
  'use strict';

  const bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  const stickyImg     = document.getElementById('sticky-atc-image');
  const stickyPrice   = document.getElementById('sticky-atc-price');
  const stickyCompare = document.getElementById('sticky-atc-compare');
  const stickyBtn     = document.getElementById('sticky-atc-btn');
  const stickySelects = bar.querySelectorAll('.sticky-atc-bar__select');
  const productData   = window.__productData__;

  if (!productData) return;

  const mainForm = document.querySelector('product-form form')
                || document.querySelector('form[action*="/cart/add"]');

  const variantInput = mainForm
    ? mainForm.querySelector('input[name="id"]')
    : null;

  const mainBtn = document.querySelector('product-form [name="add"]')
               || document.querySelector('[name="add"]');

  const formatMoney = (cents) =>
    new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
      minimumFractionDigits: 2
    }).format(cents / 100);

  const getSelectedVariant = () => {
    const selected = Array.from(stickySelects).map(s => s.value);
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    ) || null;
  };

  const updateBar = (variant) => {
    if (!variant) variant = getSelectedVariant();
    if (!variant) return;

    if (variant.featured_image?.src) {
      stickyImg.src = variant.featured_image.src;
    }

    stickyPrice.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      stickyCompare.textContent = formatMoney(variant.compare_at_price);
      stickyCompare.style.display = '';
    } else {
      stickyCompare.textContent = '';
      stickyCompare.style.display = 'none';
    }

    stickyBtn.disabled = !variant.available;

    const btnText = stickyBtn.querySelector('.sticky-atc-bar__btn-text');
    if (btnText) {
      btnText.textContent = variant.available ? 'Añadir a la bolsa' : 'Agotado';
    }
  };

  stickySelects.forEach((select) => {
    select.addEventListener('change', () => {
      const variant = getSelectedVariant();
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const mainSelects = mainForm ? mainForm.querySelectorAll('select') : [];
      Array.from(stickySelects).forEach((s, i) => {
        if (mainSelects[i]) mainSelects[i].value = s.value;
      });

      updateBar(variant);
    });
  });

  const syncFromMain = () => {
    if (!variantInput) return;
    const currentId = parseInt(variantInput.value, 10);
    const variant = productData.variants.find(v => v.id === currentId);
    if (!variant) return;

    variant.options.forEach((opt, i) => {
      if (stickySelects[i]) stickySelects[i].value = opt;
    });

    updateBar(variant);
  };

  document.addEventListener('variant:changed', syncFromMain);

  if (variantInput) {
    new MutationObserver(syncFromMain).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    variantInput.addEventListener('change', syncFromMain);
  }

  // ── Botón ────────────────────────────────────────────────
  let adding = false;

  stickyBtn.addEventListener('click', () => {
    if (adding) return;
    const variant = getSelectedVariant();
    if (!variant || !variant.available) return;

    adding = true;

    const btnText = stickyBtn.querySelector('.sticky-atc-bar__btn-text');
    if (btnText) btnText.textContent = '...';
    stickyBtn.disabled = true;

    if (variantInput) variantInput.value = variant.id;
    if (mainBtn) mainBtn.click();

    setTimeout(() => {
      adding = false;
      updateBar(variant);
    }, 1500);
  });

  // ── Visibilidad ───────────────────────────────────────────
  const observeTarget = mainBtn
    || document.querySelector('product-form')
    || mainForm;

  if (observeTarget) {
    new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          bar.classList.add('sticky-atc-bar--hidden');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          const rect = entry.boundingClientRect;
          if (rect.bottom < 0) {
            bar.classList.remove('sticky-atc-bar--hidden');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.add('sticky-atc-bar--hidden');
            bar.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }, { threshold: 0 }).observe(observeTarget);
  }

  syncFromMain();
  updateBar();

})();
